import React, { useEffect, useState } from 'react';
//FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
import { useParams } from 'react-router-dom';

export default function BizTimeList() {
    const params = useParams();
    const { axiosPostHandler } = useAxiosHook();
    /* =============== 영업시간리스트 =============== */
    const [bizDayList, setBizDayList] = useState([]);
    const bizDayListAPI = async () => {
        // const DATA = { PARTNER_CD: partner.COMN_CD };
        const DATA = { PARTNER_CD: params.cd };
        const result = await axiosPostHandler(`partnerBizDayListForAdmin.do`, DATA);
        if (!result) { return; }
        setBizDayList(result.data);
    }
    useEffect(() => {
        bizDayListAPI();
    }, [])
    /* =============== 영업시간리스트 =============== */

    return (
        <>
            <div className={{}}>
                <div className="subtitle">
                    <label>운영시간</label>
                    <button onClick={(e) => {}}><FontAwesomeIcon icon={['fal', 'pen-to-square']} />수정하기</button>{/* 수정하기버튼 */}
                </div>
                <div className={{}}>
                    {bizDayList && bizDayList.map((item) => (
                        <div className={item.DAYS === item.TODAY ? null : null}>
                            <label>{item.DAYS_STR}</label>
                            <div>
                                <label>
                                    {item.BIZ_TIME}
                                    {item.BREAK_TIME !== undefined && item.BREAK_TIME !== null ?
                                        <><br />{item.BREAK_TIME}</>
                                        : null}
                                </label>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}